module.exports = {
      id: "59f9e746596a49f506aa2e931615b2f9electricity-120v.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#59f9e746596a49f506aa2e931615b2f9electricity-120v.svg",
      toString: function () {
        return this.url;
      }
    }